import {REST_METHODS} from '@/src/app/constants/api';
import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';
import authorizedFetch from '@/src/app/utils/authorizedFetch';
import getSearchQuery from '@/src/app/utils/getSearchQuery';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

const MAX_COURSES_IN_WIDGET = 3;
const COURSES_OFFSET = 0;

const getContentCreatorResentCourses = (userId, filter) => {
  const param = [
    {
      name: 'user_id',
      value: userId,
    },
    {
      name: 'per_page',
      value: MAX_COURSES_IN_WIDGET,
    },
    {
      name: 'offset',
      value: COURSES_OFFSET,
    },
    ...getSearchQuery('filters', filter),
  ];

  const requestMethod = getAuthorizationToken()
    ? authorizedFetch
    : unauthorizedFetch;

  // @ts-ignore
  return requestMethod({
    method: REST_METHODS.GET,
    path: `/api/v1/courses/search`,
    queryParams: param,
  });
};

export default getContentCreatorResentCourses;
